<template>
  <div class="copy-section">
    <h2 class="copy-section__heading" v-html="heading"/>
    <p class="copy-section__content" v-html="description"/>
  </div>
</template>

<script>
export default {
  props: {
    heading: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .copy-section {
    @include font($akrobat-font, 300);

    text-transform: uppercase;
    letter-spacing: 0.03em;

    padding-left: $container-margin;
    padding-right: $container-margin;
    margin: 0 auto;
    max-width: 500px;
    width: 100%;

    @include media-up(xl) {
      max-width: 720px;
    }

    &__heading {
      margin: 0 0 .1em;
      font-weight: 900;
      font-size: 38px;

      @include media-up(xl) {
        font-size: 56px;
      }
    }

    &__content {
      margin: 0;
      font-size: 20px;
      position: relative;

      /deep/ strong {
        font-weight: 900;
        display: block;

        @include media-up(sm) {
          display: inline;
        }
      }

      @include media-up(xl) {
        font-size: 24px;
      }

      &::after {
        content: "";
        width: 90%;
        position: absolute;
        bottom: -.4em;
        right: -$container-margin;
        height: 1em;
        background-color: $base-opposite-color;
        z-index: -1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CopySection.vue